import { LOCALE } from "./const";

export const formatPriceWithCurrency = (price: number) => {
  const formattedPrice = formatPrice(price);
  return `${formattedPrice} USD`;
};

export const formatPrice = (price: number) => {
  const formatOptions: Intl.NumberFormatOptions = {
    style: "currency",
    currency: "USD",
  };

  return new Intl.NumberFormat(LOCALE, {
    ...formatOptions,
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(price);
};
